<template>
  <v-row class="fill-height">
    <v-col cols="10" lg="12"
           class="d-flex justify-start align-start fill-height flex-column mx-auto pa-lg-10">
      <v-sheet :max-width="$vuetify.breakpoint.lgAndUp ? '50%' : '100%'">
        <p>{{ $t('parser_message') }}:</p>
        <div class="d-flex justify-start">
          <v-btn class="mr-3 mr-lg-6" :block="$vuetify.breakpoint.mobile" @click="startParse" color="primary" tile>{{ $t('start') }}</v-btn>
          <v-btn :block="$vuetify.breakpoint.mobile" @click="openCleaningDialog" color="primary" tile>{{ $t('remove') }}</v-btn>
        </div>
      </v-sheet>
      <v-sheet class="my-6" :max-width="$vuetify.breakpoint.lgAndUp ? '50%' : '100%'">
        <p>{{ $t('parser_message_export') }}:</p>
        <div class="d-flex justify-center justify-lg-start flex-column flex-lg-row"
        >
          <v-btn :loading="loadings.xlsx"
                 :block="$vuetify.breakpoint.mobile"
                 class="d-block d-lg-inline-block"
                 tile color="primary" @click="exportIn('xlsx')">
            <span >Export in .XLSX</span>
          </v-btn>
          <v-btn :loading="loadings.pdf"
                 :block="$vuetify.breakpoint.mobile"
                 color="primary" tile class="my-3 my-lg-auto mx-lg-6 d-block d-lg-inline-block" @click="exportIn('pdf')">
            <span >Export in .PDF</span>
          </v-btn>
          <v-btn :loading="loadings.csv"
                 class="d-block d-lg-inline-block"
                 :block="$vuetify.breakpoint.mobile"
                 tile color="primary" @click="exportIn('csv')">
            <span >Export in .CSV</span>
          </v-btn>
        </div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
name: "Parser",
  data () {
    return {
      loadings: {
        xlsx: false,
        csv: false,
        pdf: false
      }
    }
  },
  methods: {
    startParse () {
      this.$http.get('api/v2/auth/start-parsing')
        .then(() => {
          this.$http.get('api/v2/auth/run')
        })
    },
    exportIn (type) {
      this.loadings[type] = true
      this.$http.get(`api/v2/auth/export-${type}`)
          .then(response => {
              window.open(
                  `${process.env.VUE_APP_API_URL}/${process.env.NODE_ENV === 'production' ? 'public/storage' : 'storage'}/${response.data.link}`,
                  '_blank'
              )
          })
          .finally(() => {
            this.loadings[type] = false
          })
    },
    openCleaningDialog () {
      this.$store.dispatch('setCleaningDialogStatus', true)
    }
  }
}
</script>

<style scoped>

</style>
